<div class="general__container">
  <h2 class="font-weight-bold my-2 d-flex align-items-center">
    <span (click)="returnToList()" class="material-icons link mr-2"
      >chevron_left</span
    >{{ currentId ? 'Detalles del sorteo' : 'Nuevo sorteo' }}
  </h2>
  <h3 class="font-weight-bold">{{ status ? status.name : '' }}</h3>
  <div class="new__giveaway__container">
    <form
      action="#"
      autocomplete="off"
      [formGroup]="giveawayForm"
      fxLayout="column nowrap"
      fxLayoutGap="1rem"
      fxLayoutAlign="center"
    >
      <div
        class="w-75"
        fxLayout="row nowrap"
        fxLayoutGap="2rem"
        fxLayoutAlign="start center"
      >
        <span fxFlex="20">Nombre del sorteo:</span>
        <mat-form-field class="w-100">
          <input matInput fxflex #nameInput formControlName="name" />
          <mat-error *ngIf="giveawayForm.get('name').hasError('required')">
            Nombre requerido
          </mat-error>
        </mat-form-field>
      </div>
      <div
        class="w-100"
        fxLayout="row nowrap"
        fxLayoutGap="2rem"
        fxLayoutAlign="start center"
      >
        <span fxFlex="15">Premio/s:</span>
        <div
          *ngIf="status.value == 0; else publishedPrizes"
          cdkDropList
          cdkDropListOrientation="horizontal"
          class="prize__list w-75"
          [ngClass]="{ 'd-none': !draws.length }"
          (cdkDropListDropped)="drop($event)"
        >
          <div
            class="prize__item"
            *ngFor="let draw of draws; let i = index"
            cdkDrag
          >
            <div class="image">
              <img
                src="{{ draw.prizeDetail ? draw.prizeDetail.image : '' }}"
                matTooltip="{{ draw.prizeDetail ? draw.prizeDetail.name : '' }}"
                alt="{{ draw.prizeDetail ? draw.prizeDetail.name : '' }}"
              />
              <a (click)="deletePrize(i)" mat-icon-button>
                <i class="material-icons">cancel</i>
              </a>
            </div>
            <h3>{{ i + 1 }}º Premio</h3>
          </div>
        </div>
        <div
          class="w-25 d-flex align-items-center"
          [ngClass]="{ 'd-none': status.value != 0 }"
        >
          <a
            mat-stroked-button
            color="primary"
            (click)="addNewPrize()"
            class="d-flex align-items-center"
          >
            <i class="material-icons">add</i> Elegir premio</a
          >
        </div>
      </div>
      <div
        class="w-75"
        fxLayout="row nowrap"
        fxLayoutGap="2rem"
        fxLayoutAlign="start center"
      >
        <span fxFlex="20">Participan quienes:</span>
        <mat-form-field class="w-100">
          <mat-select formControlName="criteria">
            <mat-option
              *ngFor="let criteria of criterias"
              [value]="criteria.id"
            >
              {{ criteria.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="giveawayForm.get('criteria').hasError('required')">
            Debe seleccionar una opcion
          </mat-error>
        </mat-form-field>
      </div>
      <div
        class="w-75"
        fxLayout="row nowrap"
        fxLayoutGap="2rem"
        fxLayoutAlign="start center"
      >
        <span fxFlex="20">Entre las fechas: </span>
        <mat-form-field class="w-50">
          <input
            matInput
            (dateChange)="checkDrawDatetime()"
            (focus)="giveawayFromDate.open()"
            [max]="giveawayForm.get('end_date').value"
            [matDatepicker]="giveawayFromDate"
            formControlName="start_date"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="giveawayFromDate"
          ></mat-datepicker-toggle>
          <mat-datepicker #giveawayFromDate></mat-datepicker>
          <mat-error
            *ngIf="giveawayForm.get('start_date').hasError('required')"
          >
            Fecha desde es requerida
          </mat-error>
          <mat-error *ngIf="giveawayForm.get('start_date').hasError('max')">
            Fecha desde no puede ser mayor a la fecha hasta
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-50">
          <input
            matInput
            (dateChange)="checkDrawDatetime()"
            (focus)="giveawayToDate.open()"
            [min]="giveawayForm.get('start_date').value"
            [matDatepicker]="giveawayToDate"
            formControlName="end_date"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="giveawayToDate"
          ></mat-datepicker-toggle>
          <mat-datepicker #giveawayToDate></mat-datepicker>
          <mat-error *ngIf="giveawayForm.get('end_date').hasError('required')">
            Fecha hasta es requerida
          </mat-error>
          <mat-error *ngIf="giveawayForm.get('end_date').hasError('min')">
            Fecha hasta no puede ser menor a la fecha desde
          </mat-error>
          <mat-error *ngIf="giveawayForm.get('end_date').hasError('max')">
            Fecha hasta no puede ser mayor a la fecha de sorteo
          </mat-error>
        </mat-form-field>
      </div>

      <div
        class="w-75"
        fxLayout="row nowrap"
        fxLayoutGap="2rem"
        fxLayoutAlign="start center"
      >
        <span fxFlex="20">Fecha de sorteo:</span>
        <span>{{ drawDatetime }}</span>
      </div>
      <div
        class="w-75"
        fxLayout="row nowrap"
        fxLayoutGap="2rem"
        fxLayoutAlign="start center"
      >
        <span fxFlex="20">Vigencia del premio:</span>
        <mat-form-field class="w-50">
          <input matInput fxflex type="number" formControlName="claim_time" />
          <mat-hint>Cantidad de días para retirar el premio</mat-hint>
          <mat-error
            *ngIf="giveawayForm.get('claim_time').hasError('required')"
          >
            Tiempo para canjear el premio es requerido
          </mat-error>
          <mat-error *ngIf="giveawayForm.get('claim_time').hasError('min')">
            El tiempo minimo para canjear son 7 dias
          </mat-error>
          <mat-error *ngIf="giveawayForm.get('claim_time').hasError('max')">
            El tiempo maximo para canjear son 60 dias
          </mat-error>
        </mat-form-field>
      </div>
      <!-- <div class="w-75" fxLayout="row nowrap"  fxLayoutGap="2rem" fxLayoutAlign="start center">
        <span fxFlex="20">Sorteo activo:</span>
        <mat-slide-toggle color="primary" formControlName="published"></mat-slide-toggle>
      </div> -->
      <!-- <div class="w-75" fxLayout="row nowrap"  fxLayoutGap="2rem" fxLayoutAlign="start center">
        <span fxFlex="20">Notificar a usuarios:</span>
        <mat-slide-toggle color="primary"></mat-slide-toggle>
      </div> -->
      <div
        class="w-75"
        fxLayout="row nowrap"
        fxLayoutGap="2rem"
        fxLayoutAlign="start center"
      >
        <span fxFlex="20">Sponsor:</span>
        <div
          *ngIf="status.value == 0; else genericSponsors"
          class="sponsor__list flex-1"
          [ngClass]="{ 'd-none': !sponsors.length }"
        >
          <div
            class="sponsor__item"
            *ngFor="let sponsor of sponsors; let i = index"
            matTooltip="{{ sponsor.name }}"
          >
            <a mat-icon-button (click)="removeSponsor(i)">
              <i class="material-icons">cancel</i>
            </a>
            <img src="{{ sponsor.image }}" alt="{{ sponsor.name }}" />
          </div>
        </div>
        <div
          class="d-flex align-items-center w-25"
          [ngClass]="{ 'd-none': status.value != 0 }"
        >
          <a
            mat-stroked-button
            color="primary"
            class="d-flex align-items-center"
            (click)="chooseGiveawaySponsor()"
          >
            <i class="material-icons">add</i>
            Elegir sponsor
          </a>
        </div>
      </div>
      <hr />
      <div class="d-flex justify-content-end align-items-center">
        <!-- <button mat-button class="mr-2">Previsualizar</button> -->
        <button
          *ngIf="status.value === 0"
          mat-raised-button
          class="mr-2 uppercase"
          color="accent"
          (click)="onNewGiveawayCreated()"
          [disabled]="!giveawayForm.valid || !draws.length"
        >
          Guardar Borrador
        </button>
        <button
          *ngIf="status.value === 0"
          mat-raised-button
          class="uppercase"
          color="primary"
          (click)="onNewGiveawayCreated(true)"
          [disabled]="!giveawayForm.valid || !draws.length"
        >
          Publicar Sorteo
        </button>
        <button
          *ngIf="status.value === 1"
          mat-raised-button
          class="uppercase mr-2"
          color="accent"
          (click)="cancelGiveaway()"
        >
          Cancelar
        </button>
        <button
          *ngIf="checkExecuteStatus()"
          mat-raised-button
          class="uppercase"
          color="primary"
          (click)="executeGiveaway()"
        >
          Ejecutar Sorteo
        </button>
      </div>
    </form>
  </div>

  <ng-template #publishedPrizes>
    <div
      class="published__prizes"
      fxLayout="column"
      fxLayoutAlign="start start"
      fxLayoutGap="2rem"
    >
      <div
        class="published__prize"
        *ngFor="let draw of draws; let i = index"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <span class="position font-weight-bold">({{ i + 1 }})</span>
        <img
          class="prize__img"
          src="{{ draw.prizeDetail ? draw.prizeDetail.image : '' }}"
          matTooltip="{{ draw.prizeDetail ? draw.prizeDetail.name : '' }}"
        />
        <div
          *ngIf="draw.winner"
          class="winner"
          fxLayout="row"
          fxLayoutGap="0.5rem"
          fxLayoutAlign="start center"
        >
          <img
            class="winner__img"
            src="{{ draw.playerDetail ? draw.playerDetail.photo : '' }}"
          />
          <span>{{ draw.playerDetail ? draw.playerDetail.username : '' }}</span>
        </div>
        <mat-chip-list class="status mr-2">
          <mat-chip
            selected
            color="warn"
            *ngIf="draw.winner && !draw.prize_claimed && !checkIfTimeExpired()"
            >Reclamo pendiente</mat-chip
          >
          <mat-chip
            selected
            color="warn"
            *ngIf="draw.winner && !draw.prize_claimed && checkIfTimeExpired()"
            >No reclamado</mat-chip
          >
          <mat-chip
            selected
            color="primary"
            *ngIf="draw.winner && draw.prize_claimed && !draw.prize_awarded"
            >Reclamo realizado</mat-chip
          >
          <mat-chip
            selected
            color="primary"
            *ngIf="draw.winner && draw.prize_claimed && draw.prize_awarded"
            >Entregado</mat-chip
          >
        </mat-chip-list>
        <h2
          *ngIf="draw.winner && !draw.prize_claimed"
          class="text-warning d-flex align-items-center my-0 mx-2"
        >
          {{ checkDrawTimeLeft() }}
        </h2>
        <a
          *ngIf="draw.winner && draw.prize_claimed && !draw.prize_awarded"
          (click)="openDeliverPrizeDialog(draw)"
          mat-raised-button
          color="accent"
          class="uppercase"
          >Entregar</a
        >
      </div>
    </div>
  </ng-template>

  <ng-template #genericSponsors>
    <div class="generic__list">
      <div
        class="generic__item"
        *ngFor="let sponsor of sponsors; let i = index"
        matTooltip="{{ sponsor.name }}"
      >
        <img src="{{ sponsor.image }}" />
        <span>{{ sponsor.name }}</span>
      </div>
    </div>
  </ng-template>
</div>
